import React, { useEffect } from 'react'

import { upsertOneWidgetWindow } from '@/entities/widgetWindows'
import { LeafletMap } from '@/shared/components/LeafletMap/LeafletMap'
import { TOOL_WIDGETS, WidgetTypeWithSuffix } from '@/shared/components/Mosaic/models/widgetType'
import { useAppDispatch } from '@/shared/store'
import { faMapLocationDot } from '@fortawesome/pro-regular-svg-icons'

import { useReplayContext } from './HistoricalReplay/ReplayContext'
import { ReplayControlPanel } from './HistoricalReplay/ReplayControlPanel'
import { useOperationMapContext } from './OperationsMapWidgetContext'

export type OperationsMapWidgetProps = {
  id: string
  widgetId: WidgetTypeWithSuffix // Widget Window id
  children: React.ReactNode // Map Widget Control
}

export const OperationsMapWidget: React.FC<OperationsMapWidgetProps> = ({ widgetId, children }) => {
  const dispatch = useAppDispatch()
  const { setWidgetId } = useOperationMapContext()
  const { isReplayPanelVisible } = useReplayContext()

  // Update widget window context and global store to render widow title, uiColor, etc.
  useEffect(() => {
    if (widgetId) {
      setWidgetId(widgetId as `Map-${string}`)
      dispatch(upsertOneWidgetWindow({
        id: widgetId,
        shiftIds: [],
        unassignedScheduleIds: [],
        liveLocationShiftIds: [],
        isActive: true,
        widgetType: TOOL_WIDGETS.Map,
        navigations: [
          {
            title: 'Map',
            icon: faMapLocationDot,
          },
        ],
      }))
    }
  }, [widgetId, dispatch, setWidgetId])


  return (
    <>
      {isReplayPanelVisible && <ReplayControlPanel />}
      <LeafletMap drawControl={false} >
        {children}
      </LeafletMap>
    </>
  )
}
